module.exports = __webpack_public_path__ + "static/img/3l.bad3b1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/3l.jpg
// module id = VIKr
// module chunks = 0